import { AppStateFacade } from '@app-state';
import { of, } from 'rxjs';
import { PageMetadataRegistry } from '../page-meta';
import * as i0 from "@angular/core";
import * as i1 from "../page-meta/page-metadata-registry";
import * as i2 from "../../app-state/app-state.facade";
var PreloadFeatureStrategy = /** @class */ (function () {
    function PreloadFeatureStrategy(_pageRegistry, _appState) {
        this._pageRegistry = _pageRegistry;
        this._appState = _appState;
    }
    PreloadFeatureStrategy.prototype.preload = function (route, resolve) {
        var page = this._pageRegistry.findByRoute("/" + route.path, true);
        if (!page) {
            return of(null);
        }
        var isFlagged = !!page.featureFlag;
        if (!isFlagged) {
            return resolve();
        }
        var isFeatureEnabled = this._appState
            .settings
            .isFeatureEnabled(page.featureFlag);
        if (isFeatureEnabled) {
            return resolve();
        }
        return of(null);
    };
    PreloadFeatureStrategy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PreloadFeatureStrategy_Factory() { return new PreloadFeatureStrategy(i0.ɵɵinject(i1.PageMetadataRegistry), i0.ɵɵinject(i2.AppStateFacade)); }, token: PreloadFeatureStrategy, providedIn: "root" });
    return PreloadFeatureStrategy;
}());
export { PreloadFeatureStrategy };
